import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { provideDashboardEcharts } from './echarts/echarts.provider';
import { dashboardFeature, DashboardEffects } from './store';

export function provideDashboardFeature() {
  return makeEnvironmentProviders([
    provideState(dashboardFeature),
    provideEffects(DashboardEffects),
    provideDashboardEcharts(),
  ]);
}
